import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "customerDetailsModal",
  tabindex: "-1",
  "aria-labelledby": "customerDetailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content border-0 shadow" }
const _hoisted_4 = { class: "modal-header border-bottom-dashed" }
const _hoisted_5 = {
  class: "modal-title fw-bold mb-1",
  id: "customerDetailsModalLabel"
}
const _hoisted_6 = { class: "text-muted mb-0" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_9 = { class: "row g-3 mb-4" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "detail-card" }
const _hoisted_12 = { class: "detail-label" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "detail-card" }
const _hoisted_15 = { class: "detail-label" }
const _hoisted_16 = { class: "details-list list-style" }
const _hoisted_17 = { class: "fs-14 text-title" }
const _hoisted_18 = { class: "fs-14 fw-bold text-title" }
const _hoisted_19 = { class: "fs-14 text-title" }
const _hoisted_20 = { class: "fs-14 fw-bold text-title" }
const _hoisted_21 = { class: "fs-14 text-title" }
const _hoisted_22 = { class: "fs-14 fw-bold text-title" }
const _hoisted_23 = { class: "fs-14 text-title" }
const _hoisted_24 = { class: "fs-14 fw-bold text-title" }
const _hoisted_25 = { class: "fs-14 text-title" }
const _hoisted_26 = { class: "fs-14 fw-bold text-title" }
const _hoisted_27 = { class: "fs-14 text-title" }
const _hoisted_28 = {
  key: 1,
  class: "modal-body py-5 text-center text-muted"
}
const _hoisted_29 = { class: "modal-footer border-top-dashed justify-content-end" }
const _hoisted_30 = {
  type: "button",
  class: "btn btn-light px-4",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t("customer_page.details_title")), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("customer_page.details_description")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": _ctx.$t('common.close')
          }, null, 8, _hoisted_7)
        ]),
        (_ctx.customer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("customer_page.customer_code")), 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.customer.code || _ctx.$t("customer_page.not_available_short")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("customer_page.deposit")), 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.customer.deposit)), 1)
                  ])
                ])
              ]),
              _createElementVNode("ul", _hoisted_16, [
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("customer_page.customer_name")), 1),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.customer.name || _ctx.$t("customer_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("customer_page.phone")), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.customer.phone || _ctx.$t("customer_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("customer_page.email")), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.customer.email || _ctx.$t("customer_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("customer_page.country")), 1),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.customer.country || _ctx.$t("customer_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("customer_page.address")), 1),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.customer.address || _ctx.$t("customer_page.not_available")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("customer_page.status")), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["status-badge", Number(_ctx.customer.status || 0) === 1 ? 'status-active' : 'status-inactive'])
                  }, _toDisplayString(Number(_ctx.customer.status || 0) === 1 ? _ctx.$t("customer_page.status_active") : _ctx.$t("customer_page.status_inactive")), 3)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t("customer_page.no_customer_selected")), 1)),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("button", _hoisted_30, _toDisplayString(_ctx.$t("common.close")), 1)
        ])
      ])
    ])
  ]))
}